import { API, destroy, get } from 'utils/api';
import { logError } from 'utils/log';
import { isOmbededThumbnailApiEnabled } from './misc';
import { BASE64_IMAGE_PREFIX } from './constants';

function getPostId(postUrl: string): string | null {
  const match = postUrl.match(/instagram\.com\/p\/([a-zA-Z0-9_-]+)/)
    || postUrl.match(/instagram\.com\/reel\/([a-zA-Z0-9_-]+)/);

  if (!match) {
    return null;
  }

  return match[1] || null;
}

async function getIGPreviewFromPageGQL(postId: string, token?: string): Promise<string> {
  // totally undocumented
  const endpoint = token ? API.END_POINTS.INSTAGRAM_POSTS.fetchSharedPostImage(postId) :
    API.END_POINTS.INSTAGRAM_POSTS.fetchPostImage(postId);
  const config = token ? { headers: { Authorization: token } } : {};

  const response: any = await get(
    endpoint,
    config,
    {
      suppressGlobalNotification: true,
      suppressAuth: !!token
    });

  return response.data;
}

async function getImageAsBase64String(postId: string, token?: string): Promise<string> {
  const url = API.END_POINTS.INSTAGRAM_POSTS.fetchPostImageContent(postId);
  const response: any = await get(
    url,
    {},
    {
      suppressGlobalNotification: true,
      suppressAuth: !!token
    });

  return `${BASE64_IMAGE_PREFIX}${response.data}`;
}

export async function fetchInstagramThumbnailUrl(
  postUrl: string,
  token?: string,
  fallbackUrl: string = ''
): Promise<string> {
  const postId = getPostId(postUrl);

  if (!postId) {
    return fallbackUrl ?? '';
  }

  try {
    if (isOmbededThumbnailApiEnabled() === false) {
      return await getImageAsBase64String(postId, token);
    }

    return await getIGPreviewFromPageGQL(postId, token);
  } catch (err) {
    // try with old post image
    if (err?.response?.status === 404) {
      try {
        await destroy(API.END_POINTS.INSTAGRAM_POSTS.deletePosts(), { data: [postId] });
      } catch (destroyError) {
        logError('Failed to mark missed post for deletion', destroyError);
      }
    }
    return fallbackUrl ?? '';
  }
}
